import type { PracticePlan } from "./yufa-practice.js";

/** A reserve is outside the initial exercise and can be selected only by its approved mapping. */
export function practicePlan(
  value: unknown,
  count: number,
): PracticePlan | undefined {
  if (value === null || typeof value !== "object") {
    return undefined;
  }
  const plan = value as PracticePlan;
  return Number.isInteger(plan.initialCount) &&
    plan.initialCount > 0 &&
    plan.initialCount < count &&
    Array.isArray(plan.variants) &&
    plan.variants.length === plan.initialCount &&
    plan.variants.every(
      (variants) =>
        Array.isArray(variants) &&
        new Set(variants).size === variants.length &&
        variants.every(
          (at) => Number.isInteger(at) && at >= plan.initialCount && at < count,
        ),
    )
    ? plan
    : undefined;
}
